import { Injectable } from '@angular/core';

import { TmsWebBaseEditService } from 'tms-web-shared';
import { PieceStatus } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class PieceStatusService extends TmsWebBaseEditService<PieceStatus, PieceStatus> {
  constructor() {
    super('PieceStatus', $localize`Piece Status`);
  }
}
